import { ILRVector3 } from "@type/lr-types";
import { Vector3 } from "three";

export function toVector3(vector:ILRVector3){
    return new Vector3(
        vector.X,
        vector.Y,
        vector.Z
    )
}